export default __webpack_public_path__ + "static/media/Verdana.4bef9605.ttf";